<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 id="_idParaDest-10" title="Part 1: Why Study Philosophy?"><span class="pagebreak" id="page17" title="17"></span></h1>
<div class="wrap">
<div class="part-number">
<a id="_idTextAnchor041"></a>PART ONE
      </div>
</div>
<h2 id="_idParaDest-12">WHY STUDY PHILOSOPHY?</h2>
<p class="body" xml:lang="en-US"><span class="pagebreak" id="page18" title="18"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pt1.vue?c6acd18a